import { useEffect } from 'react';
import { useTheme } from '@/store/use-theme';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const initTheme = useTheme((state) => state.initTheme);

  useEffect(() => {
    initTheme();
  }, [initTheme]);

  return <>{children}</>;
}
